import { defineMessages } from 'react-intl';

export const scope = 'app.containers.Launch.Login.Legal.TermsAndConditions.ConsentManagementModal'; // Define a clear scope

export default defineMessages({
  decline: {
    id: `${scope}.decline`,
    defaultMessage: 'Decline',
  },
  dontAcceptTerms: {
    id: `${scope}.dontAcceptTerms`,
    defaultMessage: "Don't Accept Terms",
  },
  acceptTerms: {
    id: `${scope}.acceptTerms`,
    defaultMessage: 'Accept License Agreement',
  },
  acceptDocument: {
    id: `${scope}.acceptDocument`,
    defaultMessage: 'Accept Terms',
  },
  reviewTerms: {
    id: `${scope}.reviewTerms`,
    defaultMessage: 'Review Terms',
  },
  termsAndConditions: {
    id: `${scope}.termsAndConditions`,
    defaultMessage: 'Terms and Conditions',
  },
  effectiveDate: {
    id: `${scope}.effectiveDate`,
    defaultMessage: 'Effective Date:',
  },
  notAcceptingTerms: {
    id: `${scope}.notAcceptingTerms`,
    defaultMessage: 'By not accepting the terms you will be logged out.',
  },
});
